/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/Star.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const Star: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 19" ref={ref} {...props}>
    <path
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12.2 6.6q.3.5.8.5l5 .7-3.6 3.6-.3.8.8 5-4.4-2.3a1 1 0 0 0-1 0l-4.4 2.3.8-5q0-.5-.3-.8L2 7.8l5-.7q.5 0 .8-.5L10 2z"
    />
  </svg>
);
Star.displayName = "Star";
